import axios from "axios-controller";
import { handleApiError } from "../utils/errorHandler";

const isFormData = (body) => {
    if (typeof FormData === "undefined") return false;
    return body instanceof FormData;
};

const buildHeaders = (token, body) => {
    const headers = {
        accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    if (!isFormData(body)) {
        headers["Content-Type"] = "application/json";
    }

    return headers;
};

export const getRequest = async (apiUrl, token) => {
    try {
        const response = await axios.get(apiUrl, {
            headers: buildHeaders(token),
        });

        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: handleApiError(error) };
    }
};

export const postRequest = async (apiUrl, body, token) => {
    try {
        const response = await axios.post(apiUrl, body, {
            headers: buildHeaders(token, body),
        });

        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: handleApiError(error) };
    }
};

export const deleteRequest = async (apiUrl, token) => {
    try {
        const response = await axios.delete(apiUrl, {
            headers: buildHeaders(token),
        });

        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: handleApiError(error) };
    }
};

export const putRequest = async (apiUrl, body, token) => {
    try {
        const response = await axios.put(apiUrl, body, {
            headers: buildHeaders(token, body),
        });

        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, error: handleApiError(error) };
    }
};